<script>
  import Documents from "./Documents.svelte";

  let showDocs = false

  function openDocs() {
    showDocs = true
  }

  function closeDocs() {
    showDocs = false
  }

</script>

<div id ="topbar" class="nav_container">
  <nav class="nav">
    <input type="checkbox" id="nav__checkbox" class="nav__checkbox">
    <label for="nav__checkbox" class="nav__toggle">
      <div class="border">
      <svg class="menu" viewBox="0 0 448 512" width="100" title="bars">
        <path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z" />
      </svg>
      <svg class="close" viewBox="0 0 384 512" width="100" title="times">
        <path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z" />
      </svg>
      </div>
    </label>
    <ul class="nav__menu">
      <!-- svelte-ignore a11y-invalid-attribute -->
      <li><a href="">
        <svg class="logo" viewBox="0 0 188 117" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path class="logo-path" d="M58.2301 1.72003C47.053 1.71806 36.1262 5.03064 26.8319 11.2388C17.5375 17.447 10.2931 26.272 6.01449 36.5977C1.73585 46.9233 0.615199 58.2859 2.79452 69.2484C4.97384 80.211 10.3552 90.281 18.2579 98.1851C26.1606 106.089 36.2296 111.472 47.1917 113.653C58.1539 115.835 69.5167 114.716 79.8431 110.439C90.1695 106.163 98.9958 98.9196 105.206 89.6263C111.415 80.3331 114.73 69.4071 114.73 58.23C114.714 43.2493 108.757 28.8864 98.1646 18.2925C87.5726 7.69853 73.2108 1.73856 58.2301 1.72003ZM58.2301 116.44C46.7123 116.442 35.4527 113.028 25.8758 106.629C16.299 100.23 8.8351 91.1346 4.4288 80.4929C0.0224981 69.8513 -1.12826 58.1418 1.12191 46.8459C3.37208 35.5501 8.92209 25.1754 17.0699 17.0346C25.2177 8.89376 35.5971 3.35259 46.8949 1.11212C58.1927 -1.12834 69.9013 0.032619 80.5391 4.44806C91.177 8.8635 100.266 16.335 106.657 25.9174C113.047 35.4997 116.452 46.7622 116.44 58.28C116.422 73.7126 110.283 88.5078 99.3702 99.4203C88.4577 110.333 73.6626 116.471 58.2301 116.49" />
          <path class="logo-path" d="M32.8998 49.5H35.1598L43.4498 70.15L51.7698 49.5H54.0198L44.6798 72.34H42.2498L32.8998 49.5Z" />
          <path class="logo-path" d="M59.0999 49.5H61.0499V70.56H72.1098V72.34H59.0999V49.5Z" />
          <path class="logo-path" d="M87.5198 49.13C89.1542 49.0922 90.7763 49.4232 92.2651 50.0984C93.754 50.7736 95.0715 51.7756 96.1199 53.03L94.6499 54.09C93.7608 53.0775 92.6633 52.2691 91.4326 51.7203C90.202 51.1714 88.8672 50.895 87.5198 50.91C82.1498 50.91 78.01 54.99 78.01 60.91C78.01 66.83 82.1498 70.97 87.5198 70.97C90.0311 70.9521 92.4373 69.9588 94.23 68.2001V62.7601H85.5698V60.9801H96.1899V68.9801C95.0932 70.1874 93.7542 71.1499 92.2603 71.8047C90.7663 72.4594 89.1509 72.7918 87.5198 72.78C81.0898 72.78 75.96 67.99 75.96 60.94C75.96 53.89 81.0898 49.13 87.5198 49.13Z" />
          <path class="logo-path" d="M104.82 49.51H102.87V72.34H104.82V49.51Z" />
          <path class="logo-path" d="M134.56 64.28C134.123 63.7388 133.565 63.3077 132.931 63.0211C132.297 62.7346 131.605 62.6006 130.91 62.63C130.498 62.5758 130.079 62.6101 129.681 62.7307C129.283 62.8514 128.916 63.0556 128.603 63.3296C128.291 63.6037 128.04 63.9413 127.869 64.3199C127.697 64.6985 127.609 65.1094 127.609 65.525C127.609 65.9407 127.697 66.3516 127.869 66.7302C128.04 67.1088 128.291 67.4464 128.603 67.7205C128.916 67.9945 129.283 68.1987 129.681 68.3193C130.079 68.44 130.498 68.4743 130.91 68.42C131.605 68.4494 132.297 68.3155 132.931 68.0289C133.565 67.7424 134.123 67.3112 134.56 66.77V64.28ZM134.56 68.06C134.003 68.6634 133.322 69.14 132.565 69.4575C131.807 69.7749 130.991 69.9258 130.17 69.9C129.574 69.9298 128.978 69.8384 128.419 69.6314C127.86 69.4244 127.348 69.1061 126.915 68.6957C126.483 68.2853 126.138 67.7914 125.901 67.2439C125.665 66.6963 125.542 66.1065 125.54 65.51C125.534 64.9127 125.652 64.3208 125.887 63.7713C126.121 63.2218 126.466 62.7268 126.901 62.3173C127.336 61.9078 127.851 61.5927 128.414 61.3918C128.976 61.1909 129.574 61.1086 130.17 61.15C130.99 61.1089 131.809 61.2499 132.568 61.5628C133.327 61.8758 134.007 62.3529 134.56 62.96V60.58C134.56 58.79 133.13 57.78 131.21 57.78C130.44 57.7714 129.677 57.9317 128.976 58.2496C128.274 58.5675 127.651 59.0353 127.15 59.62L126.15 58.19C126.824 57.4681 127.645 56.8991 128.557 56.5214C129.47 56.1436 130.453 55.9658 131.44 56C134.23 56 136.56 57.26 136.56 60.47V69.57H134.56V68.06Z" />
          <path class="logo-path" d="M140.65 66.35C141.208 66.9441 141.882 67.4181 142.63 67.7431C143.378 68.068 144.185 68.2371 145 68.24C147 68.24 148.13 67.33 148.13 66.04C148.13 64.59 146.51 64.12 144.73 63.69C142.48 63.16 139.93 62.56 139.93 59.82C139.93 57.76 141.71 56.01 144.87 56.01C145.776 55.9814 146.678 56.1368 147.522 56.4668C148.366 56.7968 149.134 57.2946 149.78 57.93L148.78 59.35C148.279 58.8052 147.668 58.3742 146.986 58.0861C146.305 57.798 145.569 57.6595 144.83 57.68C143.02 57.68 141.89 58.5 141.89 59.68C141.89 60.86 143.4 61.38 145.13 61.79C147.43 62.31 150.13 62.97 150.13 65.91C150.13 68.13 148.35 69.91 144.92 69.91C143.934 69.9565 142.949 69.7954 142.029 69.4371C141.109 69.0788 140.275 68.5313 139.58 67.83L140.65 66.35Z" />
          <path class="logo-path" d="M153.39 66.35C153.95 66.9454 154.625 67.42 155.375 67.745C156.124 68.07 156.933 68.2385 157.75 68.24C159.75 68.24 160.88 67.33 160.88 66.04C160.88 64.59 159.26 64.12 157.48 63.69C155.23 63.16 152.68 62.56 152.68 59.82C152.68 57.76 154.46 56.01 157.62 56.01C158.526 55.9814 159.428 56.1368 160.272 56.4668C161.116 56.7968 161.884 57.2946 162.53 57.93L161.53 59.35C161.029 58.8052 160.418 58.3742 159.736 58.0861C159.055 57.798 158.319 57.6595 157.58 57.68C155.77 57.68 154.64 58.5 154.64 59.68C154.64 60.86 156.15 61.38 157.88 61.79C160.18 62.31 162.88 62.97 162.88 65.91C162.88 68.13 161.1 69.91 157.67 69.91C156.684 69.9565 155.699 69.7954 154.779 69.4371C153.859 69.0788 153.025 68.5313 152.33 67.83L153.39 66.35Z" />
          <path class="logo-path" d="M167.63 62.12H176.32C176.335 61.5411 176.232 60.9651 176.019 60.4266C175.806 59.8881 175.486 59.3983 175.079 58.9864C174.672 58.5746 174.186 58.2492 173.65 58.0299C173.114 57.8105 172.539 57.7017 171.96 57.71C170.803 57.7284 169.701 58.2015 168.89 59.0268C168.08 59.8522 167.627 60.9634 167.63 62.12ZM171.98 56.01C175.98 56.01 178.35 59.13 178.35 63.11V63.63H167.63C167.64 64.2446 167.772 64.851 168.018 65.4144C168.264 65.9778 168.618 66.487 169.062 66.9127C169.505 67.3384 170.028 67.6722 170.601 67.8949C171.174 68.1175 171.785 68.2246 172.4 68.21C173.927 68.2142 175.394 67.6139 176.48 66.54L177.48 67.88C176.782 68.5512 175.955 69.0743 175.049 69.418C174.143 69.7617 173.178 69.9188 172.21 69.88C168.29 69.88 165.47 67.06 165.47 62.88C165.428 61.9933 165.565 61.1073 165.873 60.2746C166.181 59.4419 166.653 58.6797 167.261 58.0331C167.869 57.3866 168.601 56.869 169.414 56.5111C170.226 56.1533 171.102 55.9625 171.99 55.95" />
          <path class="logo-path" d="M182.08 66.81V58.15H179.89V56.34H182.09V52.72H184.09V56.34H186.78V58.15H184.09V66.37C184.09 67.37 184.53 68.07 185.44 68.07C185.697 68.0754 185.952 68.0295 186.19 67.9351C186.429 67.8406 186.646 67.6995 186.83 67.52L187.44 69.06C187.106 69.359 186.715 69.5881 186.291 69.7341C185.866 69.88 185.418 69.9399 184.97 69.91C183.02 69.91 182.04 68.79 182.04 66.81" />
          </svg>
        </a></li>
      <li><a class="item home" href="#home">Home</a></li>
      <li><a class="item" href="#soluções">Soluções</a></li>
      <li><a class="item" href="#contato">Contato</a></li>
      <li><span class="item" on:click={ openDocs }>Documentos</span></li>
    </ul>
    <Documents
      isOpen={ showDocs }
      onClose={ closeDocs }
    />
  </nav>
</div>


<style lang="scss">
@use "../styles/variables" as v;


.nav_container {
  padding: 2.5em 1em;
  z-index: 10;
  width: 100%;
}

.nav {
  &__toggle {
    position: absolute;
    cursor: pointer;
    right: 1em;

    .border {
      position: absolute;
      top: 2.2em;
      right: 1em;
      border: 2px solid #333333;
      border-radius: 100%;
      padding: 0.85em 1.2em;

      .menu {
        padding-top: 0.2em;
      }
      .close {
        padding-top: 0.2em;
        padding-bottom: 0.1em;
      }
    }

    .border:hover {
        border-color: v.$clr-purple;
      svg {
        fill: v.$clr-purple;
      }
    }

    svg {
      width: 1.2em;
      fill: black;
    }

    .close {
      display: none;
    }

  }

  &__checkbox {
    display: none;
  }

  &__menu {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    align-items: center;


    li {
      list-style: none;
      display: none;
      &:first-child {
        margin-right: auto;
        display: block;
      }
    }

    .item {
      text-decoration: none;
      text-transform: uppercase;
      color: inherit;
      font-size: 0.857rem;
      border: 1px solid transparent;
      border-radius: 2rem;
      padding: 0.25em 1.4em;
    }

    .home{
      border: 1.5px solid black;
    }

    .item:hover {
      border-color: v.$clr-purple;
      color: v.$clr-purple;
      cursor: pointer;
    }


    // logo image:
    svg {
      width: 15em;
      min-width: 50px;
      fill: black;
    }

    svg:hover {
      fill: v.$clr-purple;
    }
  }
}

// Toggle the hamburger menu in mobile view
#nav__checkbox:checked ~ ul.nav__menu li {
  display: block;
}

//Change from menu to close icon on tap
#nav__checkbox:checked ~ label.nav__toggle .close {
  display: block;
}

#nav__checkbox:checked ~ label.nav__toggle .menu {
  display: none;
}

// Desktop view
@media only screen and (min-width: v.$md-desktop-devices) {
  .nav_container {
    padding: 2.5em 8.7em;
  }
  .nav {
    &__toggle {
      display: none;
    }

    &__menu {
      flex-direction: row;


      li {
        display: block;
      }
    }
  }
}
</style>
